import { Component } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { FeedbackService } from '@app/services/feedback.service';
import { SharedService } from '@app/services/shared.service';
import { SharedModalComponent } from '@shared/components/modal/modal.component';

@Component({
  selector: 'blu-feedback-modal',
  templateUrl: './feedback-modal.component.html',
  styleUrls: ['./feedback-modal.component.scss'],
  standalone: true,
  imports: [FormsModule, SharedModalComponent],
})
export class FeedbackModalComponent {
  constructor(
    public sharedService: SharedService,
    public route: ActivatedRoute,
    public feedbackService: FeedbackService,
  ) {}
}
